module.exports = __webpack_public_path__ + "1_0_59/img/android-button.a0560e00.png";